import { readCookie, createCookie, updateUploadDocCookie } from "../utils/helpers";
import { DomainName } from "./constants";
import { getWorksimpliEndPoint, getPdfSimpliBaseURL } from "../services/api-constants";
const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

// export const getTenantId = () => {
//   const tenantId = {
//     QA: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
//     PRODUCTION: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
//     STAGING: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
//     DEVELOPMENT: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
//   };
//   return tenantId[currentEnv];
// };

export const downloadCounter = 5;
export const jobCounter = 5;
export const AdvancejobCounter = 50;
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
export const DEFAULT_USER_GUID = "a0000000-0000-0000-0000-00000000000a";

export const getTenantId = (subDomainParam) => {
  let tenantId = {};
  let domain = currentDomain(subDomainParam);
  switch (domain?.toLowerCase()) {
    case DomainName.RESUMEBUILD:
      tenantId = {
        QA: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
        PRODUCTION: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        STAGING: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        DEVELOPMENT: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
      };
      break;
    case DomainName.SIGNSIMPLI:
      tenantId = {
        QA: "7135E969-7E6B-4B40-978A-59B3C34BC2A7",
        PRODUCTION: "A7F6040A-9299-4DB7-9307-4C2A572D2956",
        STAGING: "A7F6040A-9299-4DB7-9307-4C2A572D2956",
        DEVELOPMENT: "7135E969-7E6B-4B40-978A-59B3C34BC2A7",
      };
      break;
    case DomainName.LEGALSIMPLI:
      tenantId = {
        QA: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
        PRODUCTION: "0F10199F-52CD-488D-B949-F3DCBD34070F",
        STAGING: "0F10199F-52CD-488D-B949-F3DCBD34070F",
        DEVELOPMENT: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
      };
      break;
    case DomainName.PDFSIMPLI:
      tenantId = {
        QA: "98504B3A-612F-4A9E-9426-B6FA98A054D6",
        PRODUCTION: "5F01FFC9-54E3-4BA3-9F50-B61EF634521B",
        STAGING: "5F01FFC9-54E3-4BA3-9F50-B61EF634521B",
        DEVELOPMENT: "98504B3A-612F-4A9E-9426-B6FA98A054D6",
      };
      break;
    case DomainName.WORKSIMPLI:
      tenantId = {
        QA: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
        PRODUCTION: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
        STAGING: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
        DEVELOPMENT: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
      };
      break;
    default:
      tenantId = {
        QA: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
        PRODUCTION: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        STAGING: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        DEVELOPMENT: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
      };
      break;
  }
  return tenantId[currentEnv];
};

export const getTenantGroupId = () => {
  let tenantGroupId = {};
  let domain = currentDomain();
  switch (domain?.toLowerCase()) {
    case DomainName.RESUMEBUILD:
      tenantGroupId = {
        PRODUCTION: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        STAGING: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        QA: "580C8B5A-DB83-4834-14EF-08D9501E735D",
        DEVELOPMENT: "580C8B5A-DB83-4834-14EF-08D9501E735D",
      };
      break;
    default:
      console.log("default tenant");
      tenantGroupId = {
        PRODUCTION: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        STAGING: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        QA: "580C8B5A-DB83-4834-14EF-08D9501E735D",
        DEVELOPMENT: "580C8B5A-DB83-4834-14EF-08D9501E735D",
      };
      break;
  }
  return tenantGroupId[currentEnv];
};

export const getServiceCodeForgotPwd = () => {
  return "SRVRGR";
};

export const proIPKey = () => {
  return "qGpUO64dv9znGra";
};

export const TrustPilotKey = () => {
  return "k57tr84bd96sp32xg63oc47em85if29q";
};
export const userGuid = () => {
  let userguid = readCookie("userguid");
  if (!!userguid) {
    return userguid.toLocaleLowerCase();
  } else {
    console.log("PLEASE LOGIN !!");
  }
};

export const getService = () => {
  const ServiceId = {
    QA: "BBCF66C5-D049-4EE6-98B9-AEF39E854D23",
    PRODUCTION: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
    STAGING: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
    DEVELOPMENT: "BBCF66C5-D049-4EE6-98B9-AEF39E854D23",
  };
  return ServiceId[currentEnv];
};
export const getServiceCode = () => {
  const ServiceCode = {
    QA: "SRVRGR",
    PRODUCTION: "SRVRGR",
    STAGING: "SRVRGR",
    DEVELOPMENT: "SRVRGR",
  };
  return ServiceCode[currentEnv];
};

export const getGoogleDriveClientId = () => {
  let gDriveId = "448279941363-0as5am8vori1vf6nk02n488cne8a5c1j.apps.googleusercontent.com";
  let domain = currentDomain();
  switch (domain?.toLowerCase()) {
    case DomainName.RESUMEBUILD:
      gDriveId = "448279941363-0as5am8vori1vf6nk02n488cne8a5c1j.apps.googleusercontent.com";
      break;
    case DomainName.WORKSIMPLI:
      gDriveId = "668986576337-i32d94pm2rkr0jb44njgn1q86bp7i968.apps.googleusercontent.com";
      break;
    default:
      gDriveId = "448279941363-0as5am8vori1vf6nk02n488cne8a5c1j.apps.googleusercontent.com";
      break;
  }
  return gDriveId;
};

export const getGoogleDriveDeveloperKey = () => {
  let gDriveDeveloperKey = "AIzaSyA3bZ601DpfNdDQyUADbns8hpqbXpJZAoA";
  let domain = currentDomain();
  switch (domain?.toLowerCase()) {
    case DomainName.RESUMEBUILD:
      gDriveDeveloperKey = "AIzaSyA3bZ601DpfNdDQyUADbns8hpqbXpJZAoA";
      break;
    case DomainName.WORKSIMPLI:
      gDriveDeveloperKey = "AIzaSyA3bZ601DpfNdDQyUADbns8hpqbXpJZAoA";
      break;
    default:
      gDriveDeveloperKey = "AIzaSyA3bZ601DpfNdDQyUADbns8hpqbXpJZAoA";
      break;
  }

  return gDriveDeveloperKey;
};
export const currentDomain = (subdomain) => {
  //let subdomain = "";
  let domainName = DomainName.PDFSIMPLI;
  const currentUrl = window.location.hostname;
  if (currentUrl.indexOf("signsimpli") > -1) {
    domainName = DomainName.SIGNSIMPLI;
  } else if (currentUrl.indexOf("legalsimpli") > -1) {
    domainName = DomainName.LEGALSIMPLI;
  } else if (currentUrl.indexOf("pdfsimpli") > -1) {
    domainName = DomainName.PDFSIMPLI;
  } else if (currentUrl.indexOf("resumebuild") > -1) {
    domainName = DomainName.RESUMEBUILD;
  } else if (currentUrl.indexOf("worksimpli") > -1) {
    domainName = DomainName.WORKSIMPLI;
  }
  return domainName;
};
export const currentHost = () => {
  const currentHost = window.location.origin;
  return currentHost;
};
// export const getDropboxAppKey = () => {
//   return "zn24myb1flq9r5t";
// };
// export const getResumeBuildOneDriveClientID = () => {
//   return "7b430211-4602-4943-91d5-1033a5717768"; //App Name - PDFSimpli-onedrive
// };
export const blobSignature = () => {
  const blobSign = {
    QA: "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
    PRODUCTION: "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    STAGING: "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    DEVELOPMENT: "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
  };
  return blobSign[currentEnv];
};

export const getAnonymousUserToken = () => {
  const anonymousUserToken = {
    QA: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjEwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IlZpdmVrIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvc2lkIjoiNzBiNWZiMjAtMGQ1Mi00ZWM1LTgyOGQtNTQxNTkzMmJlMzI5IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9ncm91cHNpZCI6ImQ2Y2FjYjYxLWM5NTktNDRkNC1iN2E3LWMyYzAwOWIyMzYzNSIsIm5iZiI6MTY1NzAwNjk4NiwiZXhwIjoxOTcyMzY2OTg2LCJpc3MiOiJMZWdhbFNpbXBsaSIsImF1ZCI6IlBERlNpbXBsaSJ9.Qan8dbl9yEHMwzGK1L4yk6FPZH7YpKnBRWYKoH9AyeCSXMmu_G3AVZZAPqcdZaSkf-B5U2RB6eHPz0LRA829FPVgw9r9-ouvu0JUcXNVVHptZ6Pv9btVpgVJ7gVOXrs995_iCtgfJoJqYYhW-mdF0RbjCgFdXmSEaqFTvDRKwDGFQ5JhoELd5-Dcvb3pcfTGuZ98T5K5jJd7dOp3Tj4FPrCijvV8pc3C70mFcwwfNSSi39Dd0e9dQ6yC35qG50bXGxq-CeUyV_BLKsReBSLEe5OnQzvjrIozHFDtmLFfr1qdVWKDMsyis0X-CeminHDeO1QIwJVEaAgcjfXjT_EILw",
    PRODUCTION:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjEwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IlZpdmVrIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvc2lkIjoiYjU0MDA4NDgtNzU1OS00OWM0LWIwMDEtODFiMGYyNDUxNGRlIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9ncm91cHNpZCI6ImEwMWZkOGMxLWRjZGEtNDczYi04NWNiLWVjYTcwOThmNWI2OSIsIm5iZiI6MTY1NzA4NDg4OCwiZXhwIjoxOTcyNDQ0ODg4LCJpc3MiOiJMZWdhbFNpbXBsaSIsImF1ZCI6IlBERlNpbXBsaSJ9.Je085mV9UuwHSCAHHuPzZB0mQPRoQKfbA7gDhOuWOtVhj9Spl8zp6-8DNgOpbyBv-9G5HhBe0ezgjJEzHtOtM_ZRGvBLpqROvKGnhGBmqVwsiikbxG-f4x3MJe-jXTrsn1M24a9FOOtNRbK9gC1m_wsQZlIoQvkv15--X4ZmyqA-dxLxcFIoEH52q6QzZinWQ1o-ojxM9PRnthhQ4ycdqa6kI1dIilLWXMcpxZ1P7_wKPGRm1kBECNFbM_278SMsa1Cix6MDKoQg6TAiD-hffa-n9omTc8UVmwi3eXs8Rseo8mlTZHCm4rUuyufwniXZ3kX5BXFUTpgbN4voS4_q6w",
    STAGING:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjEwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IlZpdmVrIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvc2lkIjoiYjU0MDA4NDgtNzU1OS00OWM0LWIwMDEtODFiMGYyNDUxNGRlIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9ncm91cHNpZCI6ImEwMWZkOGMxLWRjZGEtNDczYi04NWNiLWVjYTcwOThmNWI2OSIsIm5iZiI6MTY1NzA4NDg4OCwiZXhwIjoxOTcyNDQ0ODg4LCJpc3MiOiJMZWdhbFNpbXBsaSIsImF1ZCI6IlBERlNpbXBsaSJ9.Je085mV9UuwHSCAHHuPzZB0mQPRoQKfbA7gDhOuWOtVhj9Spl8zp6-8DNgOpbyBv-9G5HhBe0ezgjJEzHtOtM_ZRGvBLpqROvKGnhGBmqVwsiikbxG-f4x3MJe-jXTrsn1M24a9FOOtNRbK9gC1m_wsQZlIoQvkv15--X4ZmyqA-dxLxcFIoEH52q6QzZinWQ1o-ojxM9PRnthhQ4ycdqa6kI1dIilLWXMcpxZ1P7_wKPGRm1kBECNFbM_278SMsa1Cix6MDKoQg6TAiD-hffa-n9omTc8UVmwi3eXs8Rseo8mlTZHCm4rUuyufwniXZ3kX5BXFUTpgbN4voS4_q6w",
    DEVELOPMENT:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjEwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IlZpdmVrIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvc2lkIjoiNzBiNWZiMjAtMGQ1Mi00ZWM1LTgyOGQtNTQxNTkzMmJlMzI5IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9ncm91cHNpZCI6ImQ2Y2FjYjYxLWM5NTktNDRkNC1iN2E3LWMyYzAwOWIyMzYzNSIsIm5iZiI6MTY1NzAwNjk4NiwiZXhwIjoxOTcyMzY2OTg2LCJpc3MiOiJMZWdhbFNpbXBsaSIsImF1ZCI6IlBERlNpbXBsaSJ9.Qan8dbl9yEHMwzGK1L4yk6FPZH7YpKnBRWYKoH9AyeCSXMmu_G3AVZZAPqcdZaSkf-B5U2RB6eHPz0LRA829FPVgw9r9-ouvu0JUcXNVVHptZ6Pv9btVpgVJ7gVOXrs995_iCtgfJoJqYYhW-mdF0RbjCgFdXmSEaqFTvDRKwDGFQ5JhoELd5-Dcvb3pcfTGuZ98T5K5jJd7dOp3Tj4FPrCijvV8pc3C70mFcwwfNSSi39Dd0e9dQ6yC35qG50bXGxq-CeUyV_BLKsReBSLEe5OnQzvjrIozHFDtmLFfr1qdVWKDMsyis0X-CeminHDeO1QIwJVEaAgcjfXjT_EILw",
  };
  return anonymousUserToken[currentEnv];
};

export const defaultIPAddress = "40.80.156.205";
export const defaultCountryCode = "US";
export const defaultCurrencyCode = "USD";
export const dashboardSettingPageURl = true;
//export const googleScore = 0.4;
//export const site_key = "6Ld-aXEmAAAAAHei0VmCBOpcagiX1RQKwHEQ_qzr";
export const getCaptchaSitekey = (domain) => {
  const psSite_key = "6Ld-aXEmAAAAAHei0VmCBOpcagiX1RQKwHEQ_qzr";
  const ssSite_key = "6LcOIHwmAAAAANYgZIt6CJG-LdVxoy6I6YfhC-Dt";
  const rbSite_key = "6Lf5G3wmAAAAAGtoQk-IVo7wCIMFwk3dWIWFsKhU";
  const lsSite_key = "6Ld-aXEmAAAAAHei0VmCBOpcagiX1RQKwHEQ_qzr";
  const wsSite_key = "6LdUPosrAAAAAImB2c5zmJjMUVFo9tpd1BGiu27H";
  switch (domain) {
    case DomainName.PDFSIMPLI:
      return psSite_key;
    case DomainName.RESUMEBUILD:
      return rbSite_key;
    case DomainName.SIGNSIMPLI:
      return ssSite_key;
    case DomainName.LEGALSIMPLI:
      return lsSite_key;
    case DomainName.WORKSIMPLI:
      return wsSite_key;
    default:
      return psSite_key;
  }
};

export const googleScore = () => {
  const score = {
    DEVELOPMENT: 0.0,
    QA: 0.0,
    STAGING: 0.0,
    PRODUCTION: 0.0,
  };
  return score[currentEnv];
};
export const monthlyLimitedCategory = ["MROW000", "MROW195", "MSBRW95", "MSMBROW"];
export const monthlyFullAccessategory = ["M0SMB00", "MSMB195", "M000000", "M000195"];
export const GigWorkersWelcomeEmailSubject = "Claim up to $32,220 in Tax Credits and Receive It Within 10 Days!";
export const GigWorkersWelcomeEmailDelayMinutes = 60;
export const GigWorkersWelcomeEmailLink = "https://www.gigworkersolutions.com/?source=sf-iera9iac";
export const GigWorkersEnable = true;
export const WelcomeEmailTemplateId = "9E815D62-4AA7-4989-8817-6532AD29CA93";
export const GigWorkerUserSignUpEvent = {
  TemplateId: "9E815D62-4AA7-4989-8817-6532AD29CA93",
  EmailProvider: "SendGrid",
  TopicName: "emailengine",
  EventSubType: "Email",
  EventType: "DSBD",
};

export const getCyberSourceIframeJs = () => {
  const cyberSourceJS = {
    QA: `https://testflex.cybersource.com/microform/bundle/v2/flex-microform.min.js`,
    PRODUCTION: ``,
    STAGING: ``,
    DEVELOPMENT: `https://testflex.cybersource.com/microform/bundle/v2/flex-microform.min.js`,
  };
  return cyberSourceJS[currentEnv];
};

export const gredefaultPhoneNumber = (domain) => {
  const ps_defaultPhoneNumber = "+1-844-898-1076";
  const rb_defaultPhoneNumber = "+1-800-756-5147";
  const ss_defaultPhoneNumber = "+1-800-683-6442";
  const ls_defaultPhoneNumber = "+1-855-235-3175";
  switch (domain) {
    case DomainName.PDFSIMPLI:
      return ps_defaultPhoneNumber;
    case DomainName.RESUMEBUILD:
      return rb_defaultPhoneNumber;
    case DomainName.SIGNSIMPLI:
      return ss_defaultPhoneNumber;
    case DomainName.LEGALSIMPLI:
      return ls_defaultPhoneNumber;
    default:
      return "+1-844-898-1076";
  }
};
export const zipCodeKey = "9d984d00-c3e8-11ee-8872-ed7935d4cbba";
export const ip2LocationKey = "EADC894251A4188608F464BDC2420280";
export const getServiceToken = () => {
  const serviceToken = {
    QA: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiN2ZjOWY0MjUtMTQ2My00YThlLTg1NTYtNmM2YjM0Y2ZjZmY2Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiNTgwYzhiNWEtZGI4My00ODM0LTE0ZWYtMDhkOTUwMWU3MzVkIiwibmJmIjoxNzI4NTUzMDk2LCJleHAiOjIwNDQxMjkwOTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.KameEF9JU4__i_tmeiJQprFIpc0gGoNrXE4ti-ZqCqAhT2UflZL6NCz-herJ3pZfRTGUfsvR8n5-kPZeALbv1F_JY3sjEN4k5m-D2r4L2XjnpS7nNTznc2K5SImmounTp5F3kscXTz-qdQMInE3FjDD6U0Dbl8VPCFQR9e1XzS3_cegwTa3-tqcM7bJAsGkC17EQMec-loQiv55FISd_L8_Wq2dt3QbCnEYsR7WBMs2YWuHf2A3JVrhpr99CxRQZDVWvCDpetw9xqEvLKoViTNVKyfeN823KE26uHmRv52geyUJDnpWDCjoezFxQVWl4ODWNag8Wtw74Rx44nyl4pw",
    PRODUCTION:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiYTAxZmQ4YzEtZGNkYS00NzNiLTg1Y2ItZWNhNzA5OGY1YjY5Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiOWM3ZDk3NjYtOWViZi00N2E0LTk0ZTYtM2YxZjUwY2Q0YjJmIiwibmJmIjoxNzI4NjM4MjU2LCJleHAiOjIwNDQyMTQyNTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.f-EANyK8sM4V9keqN54Y7qZmVgkj7I_yG7N-VaFa8CsQWPYBTNe39Tj0tYAInch84TlBMGIPLUV0CRworzDvG9l8eS0XkEJ5tqCQpXFuO62ahOj814LmsdOzLn8Euw2jyy0pVrLT2mpv-FlRzK6n1SeqY-uhftp9SSkWHQ91QJI9VLUZE3_sOpf73A1-4RUPneekOEFyfLkouMjEkkcvScnkX5IsjG9VD3N-7dZSOd_gnBGSaFOKNWyFu6A2uoYP3eyK86b9wMKifhszATyWXI2ltD9eTtq9GRt48oEePIRmS0Q8l5j39h1rA_-4W7lbN1YajyYprKG3cEUlHTXwCA",
    STAGING:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiYTAxZmQ4YzEtZGNkYS00NzNiLTg1Y2ItZWNhNzA5OGY1YjY5Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiOWM3ZDk3NjYtOWViZi00N2E0LTk0ZTYtM2YxZjUwY2Q0YjJmIiwibmJmIjoxNzI4NjM4MjU2LCJleHAiOjIwNDQyMTQyNTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.f-EANyK8sM4V9keqN54Y7qZmVgkj7I_yG7N-VaFa8CsQWPYBTNe39Tj0tYAInch84TlBMGIPLUV0CRworzDvG9l8eS0XkEJ5tqCQpXFuO62ahOj814LmsdOzLn8Euw2jyy0pVrLT2mpv-FlRzK6n1SeqY-uhftp9SSkWHQ91QJI9VLUZE3_sOpf73A1-4RUPneekOEFyfLkouMjEkkcvScnkX5IsjG9VD3N-7dZSOd_gnBGSaFOKNWyFu6A2uoYP3eyK86b9wMKifhszATyWXI2ltD9eTtq9GRt48oEePIRmS0Q8l5j39h1rA_-4W7lbN1YajyYprKG3cEUlHTXwCA",
    DEVELOPMENT:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiN2ZjOWY0MjUtMTQ2My00YThlLTg1NTYtNmM2YjM0Y2ZjZmY2Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiNTgwYzhiNWEtZGI4My00ODM0LTE0ZWYtMDhkOTUwMWU3MzVkIiwibmJmIjoxNzI4NTUzMDk2LCJleHAiOjIwNDQxMjkwOTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.KameEF9JU4__i_tmeiJQprFIpc0gGoNrXE4ti-ZqCqAhT2UflZL6NCz-herJ3pZfRTGUfsvR8n5-kPZeALbv1F_JY3sjEN4k5m-D2r4L2XjnpS7nNTznc2K5SImmounTp5F3kscXTz-qdQMInE3FjDD6U0Dbl8VPCFQR9e1XzS3_cegwTa3-tqcM7bJAsGkC17EQMec-loQiv55FISd_L8_Wq2dt3QbCnEYsR7WBMs2YWuHf2A3JVrhpr99CxRQZDVWvCDpetw9xqEvLKoViTNVKyfeN823KE26uHmRv52geyUJDnpWDCjoezFxQVWl4ODWNag8Wtw74Rx44nyl4pw",
  };
  return serviceToken[currentEnv];
};
export const getFacebookClientId = () => {
  const psFb_key = "294716967702182";
  const ssFb_key = "332518932099472";
  const rbFb_key = "237961018547564";
  const lsFb_key = "725764382922248";
  const qwFb_key = "1051118503168617";
  const wsFb_key = "1256651319339467";
  let domain = currentDomain();
  switch (domain) {
    case DomainName.PDFSIMPLI:
      return psFb_key;
    case DomainName.RESUMEBUILD:
      return rbFb_key;
    case DomainName.SIGNSIMPLI:
      return ssFb_key;
    case DomainName.LEGALSIMPLI:
      return lsFb_key;
    case DomainName.WORKSIMPLI:
      return wsFb_key;
    default:
      return psFb_key;
  }
};

export const getAppleredirectUri = () => {
  const psredirectUri = getPdfSimpliBaseURL;
  const wsredirectUri = getWorksimpliEndPoint;
  let domain = currentDomain();
  switch (domain) {
    case DomainName.PDFSIMPLI:
      return psredirectUri;
    case DomainName.WORKSIMPLI:
      return wsredirectUri;
    default:
      return psredirectUri;
  }
};

export const appleClientId = () => {
  const psClientId = "com.pdfsimpli.pdfservice";
  const wsClientId = "com.worksimpli.wsservice";
  let domain = currentDomain();
  switch (domain) {
    case DomainName.PDFSIMPLI:
      return psClientId;
    case DomainName.WORKSIMPLI:
      return wsClientId;
    default:
      return psClientId;
  }
};

export const getGoogleClientId = () => {
  const psGoogle_key = "108309815588-d8c3litltbdoibd7vr078iu6njc2292u.apps.googleusercontent.com";
  const ssGoogle_key = "832193499453-f0sm7bft1ls6j8ctd5m6uh9u7qkohilf.apps.googleusercontent.com";
  const rbGoogle_key = "448279941363-0as5am8vori1vf6nk02n488cne8a5c1j.apps.googleusercontent.com";
  const lsGoogle_key = "857841731210-2vab128a29c3vhspiqvt32a4ukf10oaa.apps.googleusercontent.com";
  const qwGoogle_key = "754696431490-9fi7p3f82to8900dbcvgmbdhov9sksr1.apps.googleusercontent.com";
  const wsGoogle_key = "668986576337-i32d94pm2rkr0jb44njgn1q86bp7i968.apps.googleusercontent.com";
  let domain = currentDomain();
  switch (domain) {
    case DomainName.PDFSIMPLI:
      return psGoogle_key;
    case DomainName.RESUMEBUILD:
      return rbGoogle_key;
    case DomainName.SIGNSIMPLI:
      return ssGoogle_key;
    case DomainName.LEGALSIMPLI:
      return lsGoogle_key;
    case DomainName.WORKSIMPLI:
      return wsGoogle_key;
    default:
      return psGoogle_key;
  }
};

export const getAppleClientId = () => {
  const psApple_key =
    "MIGTAgEAMBMGByqGSM49AgEGCCqGSM49AwEHBHkwdwIBAQQggBigV0otAQMc3/Lj8N+jktqjU0SpvzNRczoO96w3Gg2gCgYIKoZIzj0DAQehRANCAASmm2XtpMSaH0tCzIGqHB9Y1LI8r5V5eM9YpJrKFbAnWnV+l+IijdpSBNT9nMM5maK7JSp8NSpg2hiwrcMwNt/u";
  const ssApple_key = "";
  const rbApple_key = "";
  const lsApple_key = "";
  const qwApple_key = "";
  let domain = currentDomain();
  switch (domain) {
    case DomainName.PDFSIMPLI:
      return psApple_key;
    case DomainName.RESUMEBUILD:
      return rbApple_key;
    case DomainName.SIGNSIMPLI:
      return ssApple_key;
    case DomainName.LEGALSIMPLI:
      return lsApple_key;
    default:
      return psApple_key;
  }
};
export const getjumpCloudClientId = () => {
  const ssJC_ClientId = getDefaultJCClientId();
  const lifeMD_JC_CLIENT_ID = getLifeMDJCClientId();
  const queryParams = new URLSearchParams(window.location.search);

  if (queryParams.has("isws")) {
    return ssJC_ClientId;
  } else {
    return lifeMD_JC_CLIENT_ID;
  }
};
export const jC_AUTH_URL = "https://oauth.id.jumpcloud.com/oauth2/auth";

const getDefaultJCClientId = () => {
  let JCClientId = {
    QA: "fb2e7ab1-ab93-4060-8017-138619db344f",
    PRODUCTION: "a7af3f6f-12a6-48db-8047-722a7c4ef5c5",
    STAGING: "a7af3f6f-12a6-48db-8047-722a7c4ef5c5",
    DEVELOPMENT: "84b30c43-7e19-4f9c-a699-a49be3f85a6e",
  };
  return JCClientId[currentEnv];
};
const getLifeMDJCClientId = () => {
  let LifeMDJCClientId = {
    QA: "",
    PRODUCTION: "",
    STAGING: "",
    DEVELOPMENT: "",
  };
  return LifeMDJCClientId[currentEnv];
};
export const getGoogleCaptchaKey = () => {
  let googleCaptchaKey = {};
  let domain = currentDomain();
  switch (domain?.toLowerCase()) {
    case DomainName.RESUMEBUILD:
      googleCaptchaKey = {
        QA: "6Lf5G3wmAAAAAGtoQk-IVo7wCIMFwk3dWIWFsKhU",
        PRODUCTION: "6Lf5G3wmAAAAAGtoQk-IVo7wCIMFwk3dWIWFsKhU",
        STAGING: "6Lf5G3wmAAAAAGtoQk-IVo7wCIMFwk3dWIWFsKhU",
        DEVELOPMENT: "6Lf5G3wmAAAAAGtoQk-IVo7wCIMFwk3dWIWFsKhU",
      };
      break;
    case DomainName.SIGNSIMPLI:
      googleCaptchaKey = {
        QA: "6LcOIHwmAAAAANYgZIt6CJG-LdVxoy6I6YfhC-Dt",
        PRODUCTION: "6LcOIHwmAAAAANYgZIt6CJG-LdVxoy6I6YfhC-Dt",
        STAGING: "6LcOIHwmAAAAANYgZIt6CJG-LdVxoy6I6YfhC-Dt",
        DEVELOPMENT: "6LcOIHwmAAAAANYgZIt6CJG-LdVxoy6I6YfhC-Dt",
      };
      break;
    case DomainName.LEGALSIMPLI:
      googleCaptchaKey = {
        QA: "",
        PRODUCTION: "",
        STAGING: "",
        DEVELOPMENT: "",
      };
      break;
    case DomainName.PDFSIMPLI:
      googleCaptchaKey = {
        QA: "6Ld-aXEmAAAAAHei0VmCBOpcagiX1RQKwHEQ_qzr",
        PRODUCTION: "6Ld-aXEmAAAAAHei0VmCBOpcagiX1RQKwHEQ_qzr",
        STAGING: "6Ld-aXEmAAAAAHei0VmCBOpcagiX1RQKwHEQ_qzr",
        DEVELOPMENT: "6Ld-aXEmAAAAAHei0VmCBOpcagiX1RQKwHEQ_qzr",
      };
      break;
    case DomainName.WORKSIMPLI:
      googleCaptchaKey = {
        QA: "6LdUPosrAAAAAImB2c5zmJjMUVFo9tpd1BGiu27H",
        PRODUCTION: "6LdUPosrAAAAAImB2c5zmJjMUVFo9tpd1BGiu27H",
        STAGING: "6LdUPosrAAAAAImB2c5zmJjMUVFo9tpd1BGiu27H",
        DEVELOPMENT: "6LdUPosrAAAAAImB2c5zmJjMUVFo9tpd1BGiu27H",
      };
      break;
    default:
      googleCaptchaKey = {
        QA: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
        PRODUCTION: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        STAGING: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        DEVELOPMENT: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
      };
      break;
  }
  return googleCaptchaKey[currentEnv];
};
export const FilesBlobPath = () => {
  const fileBlobPath = {
    QA: "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers",
    PRODUCTION: "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers",
    STAGING: "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers",
    DEVELOPMENT: "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers",
  };
  return fileBlobPath[currentEnv];
};
// export const WelcomeDocumentBlobPath = () => {
//   const welcomeDocumentPath = {
//     QA: "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers/masterdocuments/PDFSimpli_WELCOME_GUIDEBOOK.pdf",
//     PRODUCTION:
//       "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers/masterdocuments/PDFSimpli_WELCOME_GUIDEBOOK.pdf",
//     STAGING:
//       "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers/masterdocuments/PDFSimpli_WELCOME_GUIDEBOOK.pdf",
//     DEVELOPMENT:
//       "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers/masterdocuments/PDFSimpli_WELCOME_GUIDEBOOK.pdf",
//   };
//   return welcomeDocumentPath[currentEnv];
// };

//This method is used to get any file path of blob
export const getDocumentBlobPathConfig = () => {
  const DocumentPath = {
    QA: {
      WelcomeDocumentPDFSimpli:
        "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers/masterdocuments/PDFSimpli_WELCOME_GUIDEBOOK.pdf",
      WelcomeDocumentSignSimpli:
        "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers/masterdocuments/SignSimpli_WELCOME_GUIDEBOOK.pdf",
    },
    PRODUCTION: {
      WelcomeDocumentPDFSimpli:
        "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers/masterdocuments/PDFSimpli_WELCOME_GUIDEBOOK.pdf",
      WelcomeDocumentSignSimpli:
        "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers/masterdocuments/SignSimpli_WELCOME_GUIDEBOOK.pdf",
    },
    STAGING: {
      WelcomeDocumentPDFSimpli:
        "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers/masterdocuments/PDFSimpli_WELCOME_GUIDEBOOK.pdf",
      WelcomeDocumentSignSimpli:
        "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers/masterdocuments/SignSimpli_WELCOME_GUIDEBOOK.pdf",
    },
    DEVELOPMENT: {
      WelcomeDocumentPDFSimpli:
        "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers/masterdocuments/PDFSimpli_WELCOME_GUIDEBOOK.pdf",
      WelcomeDocumentSignSimpli:
        "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers/masterdocuments/SignSimpli_WELCOME_GUIDEBOOK.pdf",
    },
  };

  return DocumentPath[currentEnv];
};

export const VideoExtension = [
  "FLV",
  "WEBM",
  "MOV",
  "MKV",
  "MP4",
  "WMV",
  "AVI",
  "3GP",
  "3G2",
  "3GPP",
  "MOD",
  "MTS",
  "MXF",
  "OGG",
  "RM",
  "RMVB",
  "WTV",
  "M4V",
  "MPG",
  "SWF",
  "TS",
  "VOB",
  "M2TS",
  "MPEG",
  "DVR",
  "DV",
  "CAVS",
  "WAV",
];
export const AudioExtension = [
  "WEBA",
  "AC3",
  "M4A",
  "WMA",
  "WAV",
  "AIFC",
  "AAC",
  "MP3",
  "CAF",
  "AU",
  "AIFF",
  "OGA",
  "M4B",
  "FLAC",
  "VOC",
  "AIF",
  "AMR",
];
export const ImageExtension = [
  "MOS",
  "PS",
  "PSD",
  "RAF",
  "ARW",
  "ODG",
  "XPS",
  "GIF",
  "X3F",
  "JPEG",
  "CRW",
  "RW2",
  "MRW",
  "XCF",
  "ODD",
  "ORF",
  "NEF",
  "PNG",
  "JPG",
  "ICO",
  "ERF",
  "WEBP",
  "TIFF",
  "CR2",
  "HEIC",
  "PEF",
  "BMP",
  "RAW",
  "JFIF",
  "CR3",
  "AVIF",
  "TIF",
  "PPM",
  "ICNS",
  "DCR",
  "EPS",
  "3FR",
  "DNG",
  "HEIF",
];

export const getInitializationVector = () => {
  const ivKey = {
    QA: "2908290630030702",
    PRODUCTION: "2908290630030702",
    STAGING: "2908290630030702",
    DEVELOPMENT: "2908290630030702",
  };
  return ivKey[currentEnv];
};

export const PdfSimpliTopic = () => {
  const topicName = {
    QA: "pdfsimpli",
    PRODUCTION: "pdfsimpli_digitalsign",
    STAGING: "pdfsimpli_digitalsign",
    DEVELOPMENT: "pdfsimpli",
  };
  return topicName[currentEnv];
};
export const sasTokenExpiryHours = 48;
export const getBlobUri = () => {
  const BlobUri = {
    PRODUCTION: "https://prodlegalsimplistorage.blob.core.windows.net/",
    STAGING: "https://prodlegalsimplistorage.blob.core.windows.net/",
    QA: "https://devlegalsimpli.blob.core.windows.net/",
    DEVELOPMENT: "https://devlegalsimpli.blob.core.windows.net/",
  };

  return BlobUri[currentEnv];
};
